<template>
  <span class="manager-company-title-skeleton-ui">
    <VSkeletonLoader :width="`${width}%`" height="100%" />
  </span>
</template>

<script lang="ts" setup>
  // Config
  import {
    MIN_WIDTH_IN_PERCENTS,
    MAX_WIDTH_IN_PERCENTS,
  } from '~/modules/manager/company/title-skeleton/config';

  // Utils
  import { getRandomInt } from '~/misc/utils/number';

  // Components
  import VSkeletonLoader from '~/misc/v-skeleton-loader';

  const width: number = getRandomInt(MIN_WIDTH_IN_PERCENTS, MAX_WIDTH_IN_PERCENTS);
</script>
